export default __webpack_public_path__ + "static/media/fidelity_larceny.c2f35a46.svg";